import { TimePeriod } from '@hakimo-ui/hakimo/types';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { defaultFilterValues } from './constants';

export const pageAtom = atom<number>(1);
export const pageSizeAtom = atom<number>(30);
export const timePeriodAtom = atomWithStorage<TimePeriod>(
  'alarmGroupsList/timePeriod',
  TimePeriod.PAST_24_HOURS,
  undefined,
  { getOnInit: true }
);

export const alarmGroupFiltersAtom = atomWithStorage(
  'alarmGroupsList/filters',
  defaultFilterValues,
  undefined,
  { getOnInit: true }
);
